import React, { useContext, useState } from "react";
import { FlowHandlersContext } from "../../../../Menu/FlowContainer";
import { Stack, Typography } from "@mui/material";
import { Field } from "formik";
import { FormContainer, NavButtons } from "../../../../Menu/Flow";
import employerFlowStyles from "../../styles";
import { styles } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields/util";
export default function TextToConfirm(props) {
  const { mode, exitUrl, step, formik, displayOnly } = props;
  const { touched, values, setFieldValue } = formik;
  const flowHandlers = useContext(FlowHandlersContext);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  // Last step in the plans section, so it owns the manage-mode Next.
  let hideNext = false;
  if (mode === "manage") {
    hideNext = true;
  }

  const isValid =
    values?.allowTextSubmission === "Yes" ||
    values?.allowTextSubmission === "No";
  const showError =
    (hasAttemptedSubmit || touched.allowTextSubmission) && !isValid;

  async function handleNext(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    setHasAttemptedSubmit(true);

    if (!isValid) {
      return false;
    }

    await formik.submitForm();

    if (flowHandlers?.onNext) {
      await flowHandlers.onNext(formik.values);
    }

    return false;
  }

  return (
    <Stack spacing="30px" height="100%">
      <FormContainer>
        <Typography variant="h2" sx={employerFlowStyles.h2}>
          Text-To-Confirm
        </Typography>
        <Typography>
          Text-to-Confirm lets employees confirm monthly premium payments by
          text instead of uploading proof each month. Employees upload proof of
          their first premium payment, attest to each later payment by text, and
          respond to a quarterly text requesting proof that their coverage
          remains active.
        </Typography>

        <Stack spacing={2} sx={{ marginTop: "20px" }}>
          {/* Enable Text-To-Confirm */}
          <Stack>
            <Field name="allowTextSubmission">
              {({ field }) => (
                <select
                  {...field}
                  onChange={(e) => {
                    setFieldValue("allowTextSubmission", e.target.value);
                  }}
                  disabled={displayOnly}
                  style={{
                    ...styles.select(!field.value),
                    border: `1px solid ${showError ? "#dc2626" : "#ACBEE8"}`,
                  }}
                >
                  <option value="">
                    Would you like to enable Text-To-Confirm?
                  </option>
                  <option value="Yes">Yes — enable Text to Confirm</option>
                  <option value="No">
                    No — employees must submit each monthly premium expense
                    manually
                  </option>
                </select>
              )}
            </Field>
            {showError && (
              <div className="error-message-fields">
                Please select whether to enable Text-To-Confirm
              </div>
            )}
          </Stack>
        </Stack>
      </FormContainer>

      <NavButtons
        mode={mode}
        enableSave={true}
        exitUrl={exitUrl}
        step={step}
        hideNext={hideNext}
        onNextStep={handleNext}
      />
    </Stack>
  );
}
